import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
import { privacyIntro, privacySections } from '../data/privacy';

export default function Privacy() {
  return <LegalLayout title="Privacy Policy" updated="October 2026" intro={privacyIntro} sections={privacySections} />;
}
